export enum AccountStatus {
  Open = "OPEN",
  Closed = "CLOSED",
  Frozen = "FROZEN",
  Pending = "PENDING",
  Edd = "EDD",
  Dormant = "DORMANT",
}

export enum AccountProductType {
  Client = "CLIENT",
  Deposit = "DEPOSIT",
  Virtual = "VIRTUAL",
}

export enum TransactionOriginatorAccountFIATUSType {
  Checking = "CHECKING",
  Saving = "SAVING",
}

export enum CorporationCustomerCorporateEntityType {
  CCorpPrivate = "C_CORP_PRIVATE",
  CCorpPublic = "C_CORP_PUBLIC",
  Llc = "LLC",
  Llp = "LLP",
  Lp = "LP",
  SCorp = "S_CORP",
  Other = "OTHER",
}

export enum IndividualUsResidencyStatus {
  UsCitizen = "US_CITIZEN",
  ResidentAlien = "RESIDENT_ALIEN",
  NonResidentAlien = "NON_RESIDENT_ALIEN",
}

export enum TransactionPaymentTransactionStatus {
  Authorized = "AUTHORIZED",
  Pending = "PENDING",
  Posted = "POSTED",
  Cancelled = "CANCELLED",
}

export enum TransactionPaymentTransactionType {
  TransferIn = "TRANSFER_IN",
  TransferOut = "TRANSFER_OUT",
  Fee = "FEE",
  DebitCorrection = "DEBIT_CORRECTION",
  CreditCorrection = "CREDIT_CORRECTION",
  Trade = "TRADE",
  InternalTransfer = "INTERNAL_TRANSFER",
}

export enum TransactionPaymentCategoryType {
  Adjustment = "ADJUSTMENT",
  Deposit = "DEPOSIT",
  Exchange = "EXCHANGE",
  Transfer = "TRANSFER",
  Withdrawal = "WITHDRAWAL",
}

export enum RequestAdjustmentAdjustmentType {
  Credit = "CREDIT",
  Debit = "DEBIT",
}

export enum WithdrawalFedwireWithdrawalRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
  Crypto = "CRYPTO",
  Eft = "EFT",
}

export enum ProfileInvestingPrimarySourceOfFunds {
  Employment = "EMPLOYMENT",
  Savings = "SAVINGS",
  Winnings = "WINNINGS",
  Marital = "MARITAL",
  RealEstate = "REAL_ESTATE",
  Trust = "TRUST",
  Investment = "INVESTMENT",
  Other = "OTHER",
  Company = "COMPANY",
  CompanyCapital = "COMPANY_CAPITAL",
  Loan = "LOAN",
  PrivateCapital = "PRIVATE_CAPITAL",
  Grant = "GRANT",
}

export enum ProfileInvestingTotalInvestableAssets {
  Upto10M = "UPTO_10M",
  TenTo50M = "TEN_TO_50M",
  FiftyTo250M = "FIFTY_TO_250M",
  MoreThan250M = "MORE_THAN_250M",
}

export enum ProfileInvestingTotalAssets {
  Upto10M = "UPTO_10M",
  TenTo50M = "TEN_TO_50M",
  FiftyTo250M = "FIFTY_TO_250M",
  MoreThan250M = "MORE_THAN_250M",
}

export enum ProfileInvestingAssetAllocationToCrypto {
  Upto10 = "UPTO_10",
  TenTo25 = "TEN_TO_25",
  TwentysixTo50 = "TWENTYSIX_TO_50",
  FiftyoneTo75 = "FIFTYONE_TO_75",
  MoreThan75 = "MORE_THAN_75",
}

export enum ProfileInvestingInvestmentExperienceCrypto {
  Little = "LITTLE",
  Moderate = "MODERATE",
  Significant = "SIGNIFICANT",
}

export enum ProfileInvestingInvestmentStrategyCrypto {
  LowRisk = "LOW_RISK",
  MediumRisk = "MEDIUM_RISK",
  HighRisk = "HIGH_RISK",
  Other = "OTHER",
}

export enum ProfileInvestingInitialDepositSource {
  Deposit = "DEPOSIT",
  Wire = "WIRE",
}

export enum ProfileInvestingOngoingDepositSource {
  Deposit = "DEPOSIT",
  Wire = "WIRE",
}

export enum ProfileInvestingFrequencyOfCryptoTransactions {
  Daily = "DAILY",
  Weekly = "WEEKLY",
  Biweekly = "BIWEEKLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  SemiAnnually = "SEMI_ANNUALLY",
}

export enum BridgeAccountOwnerType {
  Individual = "individual",
  Business = "business",
}

export enum BridgeBankAccountType {
  US = "us",
  IBAN = "iban",
}

export enum ProfileInvestingCryptoInvestmentPlans {
  Custody = "CUSTODY",
  Staking = "STAKING",
  Trading = "TRADING",
  Lending = "LENDING",
  Borrowing = "BORROWING",
}

export enum ProfileInvestingTradesPerMonth {
  Upto20 = "UPTO_20",
  TwentyoneTo30 = "TWENTYONE_TO_30",
  ThirtyoneTo100 = "THIRTYONE_TO_100",
  OnehundredandoneTo200 = "ONEHUNDREDANDONE_TO_200",
  TwohundredandoneTo400 = "TWOHUNDREDANDONE_TO_400",
  MoreThan400 = "MORE_THAN_400",
}

export enum ProfileInvestingUsdValueOfCrypto {
  UpTo10k = "UPTO_10K",
  TenTo100k = "TEN_TO_100K",
  OnehundredkTo1M = "ONEHUNDREDK_TO_1M",
  OneTo10M = "ONE_TO_10M",
  TenTo50M = "TEN_TO_50M",
  FiftyTo250M = "FIFTY_TO_250M",
  MoreThan250M = "MORE_THAN_250M",
}

export enum ProfileInvestingFrequencyOfTransactions {
  Daily = "DAILY",
  Weekly = "WEEKLY",
  Biweekly = "BIWEEKLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  SemiAnnually = "SEMI_ANNUALLY",
}

export enum ProfileInvestingMonthlyCryptoInvestmentDeposit {
  Upto1k = "UPTO_1K",
  Oneto100K = "ONE_TO_100K",
  HundredkTo1M = "ONEHUNDREDK_TO_1M",
  MillionTo5M = "MILLION_TO_5M",
  MoreThan5M = "MORE_THAN_5M",
}

export enum ProfileInvestingMonthlyInvestmentDeposit {
  Upto1k = "UPTO_1K",
  Oneto100K = "ONE_TO_100K",
  HundredkTo1M = "ONEHUNDREDK_TO_1M",
  MillionTo5M = "MILLION_TO_5M",
  MoreThan5M = "MORE_THAN_5M",
}

export enum ProfileInvestingMonthlyCryptoDeposits {
  Upto5 = "UPTO_5",
  FiveTo10 = "FIVE_TO_10",
  TenTo25 = "TEN_TO_25",
  MoreThan25 = "MORE_THAN_25",
}

export enum ProfileInvestingMonthlyDeposits {
  Upto5 = "UPTO_5",
  FiveTo10 = "FIVE_TO_10",
  TenTo25 = "TEN_TO_25",
  MoreThan25 = "MORE_THAN_25",
}

export enum ProfileInvestingMonthlyCryptoInvestmentWithdrawal {
  Upto1k = "UPTO_1K",
  Oneto100K = "ONE_TO_100K",
  HundredkTo1M = "ONEHUNDREDK_TO_1M",
  MillionTo5M = "MILLION_TO_5M",
  MoreThan5M = "MORE_THAN_5M",
}

export enum ProfileInvestingMonthlyInvestmentWithdrawal {
  Upto1k = "UPTO_1K",
  Oneto100K = "ONE_TO_100K",
  HundredkTo1M = "ONEHUNDREDK_TO_1M",
  MillionTo5M = "MILLION_TO_5M",
  MoreThan5M = "MORE_THAN_5M",
}

export enum ProfileInvestingMonthlyCryptoWithdrawals {
  Upto5 = "UPTO_5",
  FiveTo10 = "FIVE_TO_10",
  TenTo25 = "TEN_TO_25",
  MoreThan25 = "MORE_THAN_25",
}

export enum ProfileInvestingMonthlyWithdrawals {
  Upto5 = "UPTO_5",
  FiveTo10 = "FIVE_TO_10",
  TenTo25 = "TEN_TO_25",
  MoreThan25 = "MORE_THAN_25",
}

export enum CounterPartyFIATPASupportedRails {
  Swift = "SWIFT",
}

export enum ApplicationFieldErrorFieldName {
  CustomerId = "customer_id",
  AccountToOpen = "account_to_open",
  ProductType = "product_type",
  AssetType = "asset_type",
  Id = "id",
  RegisteredName = "registered_name",
  TradingName = "trading_name",
  RegisteredNumber = "registered_number",
  RegisteredAddressUnitNumber = "registered_address.unit_number",
  RegisteredAddressAddressLine1 = "registered_address.address_line1",
  RegisteredAddressAddressLine2 = "registered_address.address_line2",
  RegisteredAddressAddressLine3 = "registered_address.address_line3",
  RegisteredAddressCity = "registered_address.city",
  RegisteredAddressState = "registered_address.state",
  RegisteredAddressPostalCode = "registered_address.postal_code",
  RegisteredAddressCountryCode = "registered_address.country_code",
  TelephoneNumber = "telephone_number",
  WebsiteAddress = "website_address",
  StateOfIncorporation = "state_of_incorporation",
  CountryOfIncorporation = "country_of_incorporation",
  CorporateEntityType = "corporate_entity_type",
  ContactTitle = "contact_title",
  ContactFirstName = "contact_first_name",
  ContactLastName = "contact_last_name",
  ContactTelephoneNumber = "contact_telephone_number",
  ContactEmailAddress = "contact_email_address",
  PhysicalAddressUnitNumber = "physical_address.unit_number",
  PhysicalAddressAddressLine1 = "physical_address.address_line1",
  PhysicalAddressAddressLine2 = "physical_address.address_line2",
  PhysicalAddressAddressLine3 = "physical_address.address_line3",
  PhysicalAddressCity = "physical_address.city",
  PhysicalAddressState = "physical_address.state",
  PhysicalAddressPostalCode = "physical_address.postal_code",
  PhysicalAddressCountryCode = "physical_address.country_code",
  PrimaryBusiness = "primary_business",
  DescriptionOfBusinessNature = "description_of_business_nature",
  IsCharitable = "is_charitable",
  BusinessJurisdictions = "business_jurisdictions",
  FundsSendReceiveJurisdictions = "funds_send_receive_jurisdictions",
  NewYorkOffice = "new_york_office",
  EngageInActivities = "engage_in_activities",
  RegulatedStatus = "regulated_status",
  RegulationAgencyRegulationNumber = "regulation_agency_regulation_number",
  ControlExemptionReason = "control_exemption_reason",
  VendorsAndCounterparties = "vendors_and_counterparties",
  PrimarySourceOfFunds = "primary_source_of_funds",
  TotalInvestableAssets = "total_investable_assets",
  TotalAssets = "total_assets",
  AssetAllocationToCrypto = "asset_allocation_to_crypto",
  InvestmentExperienceCrypto = "investment_experience_crypto",
  InvestmentStrategyCrypto = "investment_strategy_crypto",
  InitialDepositSource = "initial_deposit_source",
  OngoingDepositSource = "ongoing_deposit_source",
  FrequencyOfCryptoTransactions = "frequency_of_crypto_transactions",
  CryptoInvestmentPlans = "crypto_investment_plans",
  InvestmentProceedsUse = "investment_proceeds_use",
  ExpectedCryptoAssets = "expected_crypto_assets",
  PerformTransfersWithUnhostedWallets = "perform_transfers_with_unhosted_wallets",
  KnownUnhostedWalletAddresses = "known_unhosted_wallet_addresses",
  TradesPerMonth = "trades_per_month",
  UsdValueOfCrypto = "usd_value_of_crypto",
  FrequencyOfTransactions = "frequency_of_transactions",
  MonthlyCryptoInvestmentDeposit = "monthly_crypto_investment_deposit",
  MonthlyInvestmentDeposit = "monthly_investment_deposit",
  MonthlyCryptoDeposits = "monthly_crypto_deposits",
  MonthlyDeposits = "monthly_deposits",
  MonthlyCryptoInvestmentWithdrawal = "monthly_crypto_investment_withdrawal",
  MonthlyInvestmentWithdrawal = "monthly_investment_withdrawal",
  MonthlyCryptoWithdrawals = "monthly_crypto_withdrawals",
  MonthlyWithdrawals = "monthly_withdrawals",
  TradeInternationally = "trade_internationally",
  TradeJurisdictions = "trade_jurisdictions",
}

export enum ApplicationFieldErrorFieldStatus {
  Incomplete = "INCOMPLETE",
  ReadyForSubmission = "READY_FOR_SUBMISSION",
  ChangesRequested = "CHANGES_REQUESTED",
  Approved = "APPROVED",
}

export enum IndividualEmploymentStatus {
  Employee = "EMPLOYEE",
  SelfEmployed = "SELF_EMPLOYED",
  Retired = "RETIRED",
  Unemployed = "UNEMPLOYED",
  Other = "OTHER",
}

export enum BooleanEnum {
  Yes = "YES",
  No = "NO",
}

export enum PrimaryPurposeEnum {
  BusinessTransactions = "business_transactions",
  CharitableDonations = "charitable_donations",
  PaymentsToFriendsOrFamilyAbroad = "payments_to_friends_or_family_abroad",
  Payroll = "payroll",
  InvestmentPurposes = "investment_purposes",
  PersonalOrLivingExpenses = "personal_or_living_expenses",
  ProtectWealth = "protect_wealth",
  PurchaseGoodsAndServices = "purchase_goods_and_services",
  ReceivePaymentsForGoodsAndServices = "receive_payments_for_goods_and_services",
  TaxOptimization = "tax_optimization",
  Other = "other",
}

export enum BridgeMostRecentOccupation {
  AccountantAndAuditor = "132011",
  Actor = "272011",
  Actuary = "152011",
  Acupuncturist = "291291",
  AdhesiveBondingMachineOperatorAndTender = "519191",
  AdministrativeServicesManager = "113012",
  AdvertisingAndPromotionsManager = "112011",
  AdvertisingSalesAgent = "413011",
  AerospaceEngineer = "172011",
  AgentAndBusinessManagerOfArtists = "131011",
  AgriculturalAndFoodScienceTechnician = "194010",
  AgriculturalAndFoodScientist = "191010",
  AgriculturalEngineer = "172021",
  AgriculturalInspector = "452011",
  AirTrafficControllerAndAirfieldOperationsSpecialist = "532020",
  AircraftMechanicAndServiceTechnician = "493011",
  AircraftPilotsAndFlightEngineer = "532010",
  AircraftStructureAssembler = "512011",
  AmbulanceDriverAndAttendant = "533011",
  AnimalBreeder = "452021",
  AnimalCaretaker = "392021",
  AnimalControlWorker = "339011",
  AnimalTrainer = "392011",
  Architect = "171011",
  ArchitecturalAndCivilDrafter = "173011",
  ArchitecturalAndEngineeringManager = "119041",
  ArchivistCuratorAndMuseumTechnician = "254010",
  ArtistAndRelatedWorker = "271010",
  AstronomerAndPhysicist = "192010",
  AthletesAndSportsCompetitor = "272021",
  AtmosphericAndSpaceScientist = "192021",
  Audiologist = "291181",
  AudiovisualEquipmentInstallerAndRepairer = "492097",
  AutomotiveBodyAndRelatedRepairer = "493021",
  AutomotiveGlassInstallerAndRepairer = "493022",
  AutomotiveServiceTechnicianAndMechanic = "493023",
  AvionicsTechnician = "492091",
  BaggagePorterBellhopAndConcierge = "396010",
  Bailiff = "333011",
  Baker = "513011",
  Barber = "395011",
  Bartender = "353011",
  BillAndAccountCollector = "433011",
  BillingAndPostingClerk = "433021",
  BioengineerAndBiomedicalEngineer = "172031",
  BiologicalScientist = "191020",
  BiologicalTechnician = "194021",
  Boilermaker = "472011",
  BookkeepingAccountingAndAuditingClerk = "433031",
  BrickmasonBlockmasonAndStonemason = "472020",
  BroadcastAnnouncerAndRadioDiscJockey = "273011",
  BroadcastSoundAndLightingTechnician = "274010",
  BrokerageClerk = "434011",
  BudgetAnalyst = "132031",
  BusAndTruckMechanicAndDieselEngineSpecialist = "493031",
  BusinessOperationsSpecialistOther = "131199",
  ButcherAndOtherMeatProcessingWorker = "513020",
  BuyerAndPurchasingAgentFarmProducts = "131021",
  CabinetmakerAndBenchCarpenter = "517011",
  CardiovascularTechnologistAndTechnician = "292031",
  CargoAndFreightAgent = "435011",
  Carpenter = "472031",
  CarpetFloorAndTileInstallerAndFinisher = "472040",
  Cashier = "412010",
  CementMasonConcreteFinisherAndTerrazzoWorker = "472050",
  ChefAndHeadCook = "351011",
  ChemicalEngineer = "172041",
  ChemicalProcessingMachineOperatorAndTender = "519010",
  ChemicalTechnician = "194031",
  ChemistAndMaterialsScientist = "192030",
  ChiefExecutive = "111011",
  ChildFamilyAndSchoolSocialWorker = "211021",
  ChildcareWorker = "399011",
  Chiropractor = "291011",
  CivilEngineer = "172051",
  ClaimsAdjusterAppraiserExaminerAndInvestigator = "131030",
  CleanerOfVehiclesAndEquipment = "537061",
  Clergy = "212011",
  ClinicalAndCounselingPsychologist = "193033",
  ClinicalLaboratoryTechnologistAndTechnician = "292010",
  CoachesAndScout = "272022",
  CoinVendingAndAmusementMachineServicerAndRepairer = "499091",
  CommercialAndIndustrialDesigner = "271021",
  CommercialDiver = "499092",
  CommunicationsEquipmentOperatorOther = "432099",
  CompensationAndBenefitsManager = "113111",
  CompensationBenefitsAndJobAnalysisSpecialist = "131141",
  ComplianceOfficer = "131041",
  ComputerAndInformationResearchScientist = "151221",
  ComputerAndInformationSystemsManager = "113021",
  ComputerHardwareEngineer = "172061",
  ComputerNetworkArchitect = "151241",
  ComputerNumericallyControlledToolOperatorAndProgrammer = "519160",
  ComputerOccupationOther = "151299",
  ComputerProgrammer = "151251",
  ComputerSupportSpecialist = "151230",
  ComputerSystemsAnalyst = "151211",
  ComputerAutomatedTellerAndOfficeMachineRepairer = "492011",
  ConservationScientistAndForester = "191030",
  ConstructionAndBuildingInspector = "474011",
  ConstructionEquipmentOperator = "472070",
  ConstructionLaborer = "472061",
  ConstructionManager = "119021",
  ControlAndValveInstallerAndRepairer = "499010",
  ConveyorDredgeAndHoistAndWinchOperator = "5370XX",
  Cook = "352010",
  CorrectionalOfficerAndJailer = "333012",
  CorrespondenceClerk = "434021",
  CostEstimator = "131051",
  CounselorOther = "211019",
  CounterAndRentalClerk = "412021",
  CourierAndMessenger = "435021",
  CourtReporterAndSimultaneousCaptioner = "273092",
  CourtMunicipalAndLicenseClerk = "434031",
  CraneAndTowerOperator = "537021",
  CreditAnalyst = "132041",
  CreditAuthorizerCheckerAndClerk = "434041",
  CreditCounselorAndLoanOfficer = "132070",
  CrossingGuardAndFlagger = "339091",
  CrushingGrindingPolishingMixingAndBlendingWorker = "519020",
  CustomerServiceRepresentative = "434051",
  CuttingWorker = "519030",
  CuttingPunchingAndPressMachineOperator = "514031",
  DancerAndChoreographer = "272030",
  DataLabelerAndDataEntryKeyer = "439021",
  DatabaseAdministratorAndArchitect = "15124X",
  DentalAndOphthalmicLaboratoryTechnician = "519080",
  DentalAssistant = "319091",
  DentalHygienist = "291292",
  Dentist = "291020",
  DerrickRotaryDrillAndServiceUnitOperator = "475010",
  DesktopPublisher = "439031",
  DetectiveAndCriminalInvestigator = "333021",
  DiagnosticMedicalSonographer = "292032",
  DieteticTechnicianAndOphthalmicMedicalTechnician = "29205X",
  DietitianAndNutritionist = "291031",
  DiningRoomAndCafeteriaAttendant = "359011",
  DirectorReligiousActivitiesAndEducation = "212021",
  DiscJockeyExceptRadio = "272091",
  Dishwasher = "359021",
  DispatcherExceptPoliceFireAndAmbulance = "435032",
  DoorToDoorSalesWorkerNewsAndStreetVendor = "419091",
  DriverSalesWorkerAndTruckDriver = "533030",
  DrywallInstallerCeilingTileInstallerAndTaper = "472080",
  EarthDrillerExceptOilAndGas = "475023",
  Economist = "193011",
  Editor = "273041",
  EducationAndChildcareAdministrator = "119030",
  EducationalGuidanceAndCareerCounselorAndAdvisor = "211012",
  ElectricMotorPowerToolAndRelatedRepairer = "492092",
  ElectricalAndElectronicEngineeringTechnician = "173023",
  ElectricalAndElectronicsEngineer = "172070",
  ElectricalAndElectronicsInstallerAndRepairer = "492093",
  ElectricalAndElectronicsRepairerIndustrialAndUtility = "49209X",
  ElectricalPowerLineInstallerAndRepairer = "499051",
  ElectricalElectronicsAndElectromechanicalAssembler = "512020",
  Electrician = "472111",
  ElementaryAndMiddleSchoolTeacher = "252020",
  ElevatorAndEscalatorInstallerAndRepairer = "474021",
  EligibilityInterviewerGovernmentPrograms = "434061",
  EmbalmerCrematoryOperatorAndFuneralAttendant = "3940XX",
  EmergencyManagementDirector = "119161",
  EmergencyMedicalTechnician = "292042",
  EmergencyMedicinePhysician = "291214",
  EngineAndOtherMachineAssembler = "512031",
  EngineerOther = "172199",
  EntertainerAndPerformerOther = "272099",
  EntertainmentAndRecreationManager = "119070",
  EnvironmentalEngineer = "172081",
  EnvironmentalScienceAndGeoscienceTechnician = "194040",
  EnvironmentalScientistAndSpecialist = "192041",
  EtcherAndEngraver = "519194",
  ExcavatingAndLoadingMachineAndDraglineOperator = "475022",
  ExecutiveSecretaryAndAdministrativeAssistant = "436011",
  ExercisePhysiologist = "291128",
  ExerciseTrainerAndGroupFitnessInstructor = "399031",
  ExplosivesWorkerOrdnanceHandlingExpertAndBlaster = "475032",
  ExtrudingFormingPressingAndCompactingMachineSetter = "519041",
  FacilitiesManager = "113013",
  FarmerRancherAndOtherAgriculturalManager = "119013",
  FashionDesigner = "271022",
  FastFoodAndCounterWorker = "353023",
  FenceErector = "474031",
  FileClerk = "434071",
  FinancialAndInvestmentAnalyst = "132051",
  FinancialClerkOther = "433099",
  FinancialExaminer = "132061",
  FinancialManager = "113031",
  FireInspector = "332020",
  Firefighter = "332011",
  FirstLineEnlistedMilitarySupervisor = "552010",
  FirstLineSupervisorOfConstructionTradesAndExtractionWorker = "471011",
  FirstLineSupervisorOfCorrectionalOfficer = "331011",
  FirstLineSupervisorOfFarmingFishingAndForestryWorker = "451011",
  FirstLineSupervisorOfFirefightingAndPreventionWorker = "331021",
  FirstLineSupervisorOfFoodPreparationAndServingWorkers = "351012",
  FirstLineSupervisorOfHousekeepingAndJanitorialWorkers = "371011",
  FirstLineSupervisorOfLandscapingLawnServiceAndGroundskeepingWorkers = "371012",
  FirstLineSupervisorOfMechanicsInstallersAndRepairers = "491011",
  FirstLineSupervisorOfNonRetailSalesWorkers = "411012",
  FirstLineSupervisorOfOfficeAndAdministrativeSupportWorkers = "431011",
  FirstLineSupervisorOfPoliceAndDetective = "331012",
  FirstLineSupervisorOfProductionAndOperatingWorker = "511011",
  FirstLineSupervisorOfProtectiveServiceWorkerOther = "331099",
  FirstLineSupervisorOfRetailSalesWorkers = "411011",
  FirstLineSupervisorOfSecurityWorker = "331091",
  FishAndGameWarden = "333031",
  FishingAndHuntingWorker = "453031",
  FlightAttendant = "532031",
  FloralDesigner = "271023",
  FoodAndTobaccoRoastingBakingAndDryingMachineOperatorAndTender = "513091",
  FoodBatchmaker = "513092",
  FoodCookingMachineOperatorAndTender = "513093",
  FoodPreparationAndServingRelatedWorkerOther = "359099",
  FoodPreparationWorker = "352021",
  FoodProcessingWorkerOther = "513099",
  FoodServerNonrestaurant = "353041",
  FoodServiceManager = "119051",
  ForestAndConservationWorker = "454011",
  FormingMachineSetterOperatorAndTenderMetalAndPlastic = "514020",
  Fundraiser = "131131",
  FuneralHomeManager = "119171",
  FurnaceKilnOvenDrierAndKettleOperatorAndTender = "519051",
  FurnitureFinisher = "517021",
  GamblingCageWorker = "433041",
  GamblingServicesWorker = "393010",
  GeneralAndOperationsManager = "111021",
  GeoscientistAndHydrologistExceptGeographer = "19204X",
  Glazier = "472121",
  GraderAndSorterAgriculturalProduct = "452041",
  GraphicDesigner = "271024",
  GrindingLappingPolishingAndBuffingMachineToolSetterOperatorAndTenderMetalAndPlastic = "514033",
  HairdresserHairstylistAndCosmetologist = "395012",
  HazardousMaterialsRemovalWorker = "474041",
  HealthcareDiagnosingOrTreatingPractitionerOther = "291299",
  HealthcareSocialWorker = "211022",
  HeatingAirConditioningAndRefrigerationMechanicAndInstaller = "499021",
  HeavyVehicleAndMobileEquipmentServiceTechnicianAndMechanic = "493040",
  HelperInstallationMaintenanceAndRepairWorker = "499098",
  HelperProductionWorker = "519198",
  HelperConstructionTrade = "473010",
  HighwayMaintenanceWorker = "474051",
  HomeApplianceRepairer = "499031",
  HomeHealthAide = "311121",
  HostAndHostessRestaurantLoungeAndCoffeeShop = "359031",
  HotelMotelAndResortDeskClerk = "434081",
  HumanResourcesAssistantExceptPayrollAndTimekeeping = "434161",
  HumanResourcesManager = "113121",
  HumanResourcesWorker = "131070",
  IndustrialAndRefractoryMachineryMechanic = "49904X",
  IndustrialEngineerIncludingHealthAndSafety = "172110",
  IndustrialProductionManager = "113051",
  IndustrialTruckAndTractorOperator = "537051",
  InformationAndRecordClerkOther = "434199",
  InformationSecurityAnalyst = "151212",
  InspectorTesterSorterSamplerAndWeigher = "519061",
  InsulationWorker = "472130",
  InsuranceClaimsAndPolicyProcessingClerk = "439041",
  InsuranceSalesAgent = "413021",
  InsuranceUnderwriter = "132053",
  InteriorDesigner = "271025",
  InterpreterAndTranslator = "273091",
  InterviewerExceptEligibilityAndLoan = "434111",
  JanitorAndBuildingCleaner = "37201X",
  JewelerAndPreciousStoneAndMetalWorker = "519071",
  JudgeMagistrateAndOtherJudicialWorker = "231020",
  JudicialLawClerk = "231012",
  LaborerAndFreightStockAndMaterialMoverHand = "537062",
  LandscapeArchitect = "171012",
  LandscapingAndGroundskeepingWorker = "373011",
  LaundryAndDryCleaningWorker = "516011",
  Lawyer = "231011",
  LegalSecretaryAndAdministrativeAssistant = "436012",
  LegalSupportWorkerOther = "232099",
  Legislator = "111031",
  LibrarianAndMediaCollectionsSpecialist = "254022",
  LibraryAssistantClerical = "434121",
  LibraryTechnician = "254031",
  LicensedPracticalAndLicensedVocationalNurse = "292061",
  LifeScientistOther = "191099",
  LoanInterviewerAndClerk = "434131",
  LocksmithAndSafeRepairer = "499094",
  LocomotiveEngineerAndOperator = "534010",
  LodgingManager = "119081",
  LoggingWorker = "454020",
  Logistician = "131081",
  MachineFeederAndOffbearer = "537063",
  Machinist = "514041",
  MagneticResonanceImagingTechnologist = "292035",
  MaidsAndHousekeepingCleaner = "372012",
  MailClerkAndMailMachineOperatorExceptPostalService = "439051",
  MaintenanceAndRepairWorkerGeneral = "499071",
  MaintenanceWorkerMachinery = "499043",
  ManagementAnalyst = "131111",
  ManagerOther = "119199",
  ManicuristAndPedicurist = "395092",
  ManufacturedBuildingAndMobileHomeInstaller = "499095",
  MarineEngineerAndNavalArchitect = "172121",
  MarketResearchAnalystAndMarketingSpecialist = "131161",
  MarketingManager = "112021",
  MarriageAndFamilyTherapist = "211013",
  MassageTherapist = "319011",
  MaterialsEngineer = "172131",
  Mathematician = "152021",
  MechanicalEngineer = "172141",
  MediaAndCommunicationEquipmentWorkerOther = "274099",
  MediaAndCommunicationWorkerOther = "273099",
  MedicalAndHealthServicesManager = "119111",
  MedicalAssistant = "319092",
  MedicalRecordsSpecialist = "292072",
  MedicalScientist = "191040",
  MedicalSecretaryAndAdministrativeAssistant = "436013",
  MedicalTranscriptionist = "319094",
  MeetingConventionAndEventPlanner = "131121",
  MentalHealthAndSubstanceAbuseSocialWorker = "211023",
  MentalHealthCounselor = "211014",
  MerchandiseDisplayerAndWindowTrimmer = "271026",
  MetalFurnaceOperatorTenderPourerAndCaster = "514050",
  MeterReaderUtilities = "435041",
  MilitaryEnlistedTacticalOperationsAndAirWeaponsSpecialist = "553010",
  MilitaryOfficerSpecialAndTacticalOperationsLeader = "551010",
  MilitaryRankNotSpecified = "554010",
  Millwright = "499044",
  MiningAndGeologicalEngineerIncludingMiningSafetyEngineer = "172151",
  MiscellaneousAgriculturalWorker = "452090",
  MiscellaneousConstructionAndRelatedWorker = "474090",
  MiscellaneousHealthTechnologistAndTechnician = "292090",
  MiscellaneousPlantAndSystemOperator = "518090",
  MiscellaneousSocialScientistAndRelatedWorker = "193090",
  MiscellaneousVehicleAndMobileEquipmentMechanicInstallerAndRepairer = "493090",
  ModelMakerAndPatternmakerMetalAndPlastic = "514060",
  ModelDemonstratorAndProductPromoter = "419010",
  MolderAndMoldingMachineSetterOperatorAndTenderMetalAndPlastic = "514070",
  MolderShaperAndCasterExceptMetalAndPlastic = "519195",
  MorticianUndertakerAndFuneralArranger = "394031",
  MotorVehicleOperatorOther = "533099",
  MusicDirectorAndComposer = "272041",
  MusicianAndSinger = "272042",
  NaturalSciencesManager = "119121",
  NetworkAndComputerSystemsAdministrator = "151244",
  NewAccountsClerk = "434141",
  NewsAnalystReporterAndJournalist = "273023",
  NuclearEngineer = "172161",
  NuclearMedicineTechnologistAndMedicalDosimetrist = "29203X",
  NuclearTechnician = "194051",
  NurseAnesthetist = "291151",
  NurseMidwife = "291161",
  NursePractitioner = "291171",
  NursingAssistant = "311131",
  OccupationalHealthAndSafetySpecialistAndTechnician = "195010",
  OccupationalTherapist = "291122",
  OccupationalTherapyAssistantAndAide = "312010",
  OfficeAndAdministrativeSupportWorkerOther = "439199",
  OfficeClerkGeneral = "439061",
  OfficeMachineOperatorExceptComputer = "439071",
  OperationsResearchAnalyst = "152031",
  OpticianDispensing = "292081",
  Optometrist = "291041",
  OrderClerk = "434151",
  OrderlyAndPsychiatricAide = "31113X",
  OtherAssemblerAndFabricator = "5120XX",
  OtherCommunityAndSocialServiceSpecialist = "21109X",
  OtherDesigner = "27102X",
  OtherDrafter = "17301X",
  OtherEducationalInstructionAndLibraryWorker = "2590XX",
  OtherEngineeringTechnologistAndTechnician = "17302X",
  OtherEntertainmentAttendantAndRelatedWorker = "3930XX",
  OtherExtractionWorker = "4750XX",
  OtherFinancialSpecialist = "1320XX",
  OtherGroundsMaintenanceWorker = "37301X",
  OtherHealthcarePractitionerAndTechnicalOccupation = "299000",
  OtherHealthcareSupportWorker = "31909X",
  OtherInstallationMaintenanceAndRepairWorker = "49909X",
  OtherLifePhysicalAndSocialScienceTechnician = "1940XX",
  OtherMachineToolSetterOperatorAndTenderMetalAndPlastic = "51403X",
  OtherMaterialMovingWorker = "5371XX",
  OtherMathematicalScienceOccupation = "1520XX",
  OtherMetalWorkerAndPlasticWorker = "514XXX",
  OtherPersonalAppearanceWorker = "39509X",
  OtherPhysician = "2912XX",
  OtherProductionEquipmentOperatorAndTender = "51919X",
  OtherProductionWorker = "5191XX",
  OtherProtectiveServiceWorker = "33909X",
  OtherPsychologist = "19303X",
  OtherRailTransportationWorker = "5340XX",
  OtherTeacherAndInstructor = "2530XX",
  OtherTextileApparelAndFurnishingsWorker = "51609X",
  OtherTransportationWorker = "5360XX",
  OtherWoodworker = "5170XX",
  PackagingAndFillingMachineOperatorAndTender = "519111",
  PackerAndPackagerHand = "537064",
  PainterAndPaperhanger = "472140",
  PaintingWorker = "519120",
  PaperGoodsMachineSetterOperatorAndTender = "519196",
  ParalegalAndLegalAssistant = "232011",
  Paramedic = "292043",
  ParkingAttendant = "536021",
  ParkingEnforcementWorker = "333041",
  PartsSalesperson = "412022",
  PassengerAttendant = "536061",
  PayrollAndTimekeepingClerk = "433051",
  PersonalCareAndServiceWorkerOther = "399099",
  PersonalFinancialAdvisor = "132052",
  PersonalServiceManagerOther = "119179",
  PestControlWorker = "372021",
  PetroleumEngineer = "172171",
  Pharmacist = "291051",
  PharmacyAide = "319095",
  PharmacyTechnician = "292052",
  Phlebotomist = "319097",
  Photographer = "274021",
  PhotographicProcessWorkerAndProcessingMachineOperator = "519151",
  PhysicalScientistOther = "192099",
  PhysicalTherapist = "291123",
  PhysicalTherapistAssistantAndAide = "312020",
  PhysicianAssistant = "291071",
  Pipelayer = "472151",
  PlastererAndStuccoMason = "472161",
  PlumberPipefitterAndSteamfitter = "472152",
  Podiatrist = "291081",
  PoliceOfficer = "333050",
  PostalServiceClerk = "435051",
  PostalServiceMailCarrier = "435052",
  PostalServiceMailSorterProcessorAndProcessingMachineOperator = "435053",
  PostmasterAndMailSuperintendent = "119131",
  PostsecondaryTeacher = "251000",
  PowerPlantOperatorDistributorAndDispatcher = "518010",
  PrecisionInstrumentAndEquipmentRepairer = "499060",
  PrepressTechnicianAndWorker = "515111",
  PreschoolAndKindergartenTeacher = "252010",
  PresserTextileGarmentAndRelatedMaterial = "516021",
  PrintBindingAndFinishingWorker = "515113",
  PrintingPressOperator = "515112",
  PrivateDetectiveAndInvestigator = "339021",
  ProbationOfficerAndCorrectionalTreatmentSpecialist = "211092",
  ProcurementClerk = "433061",
  ProducerAndDirector = "272012",
  ProductionPlanningAndExpeditingClerk = "435061",
  ProjectManagementSpecialist = "131082",
  ProofreaderAndCopyMarker = "439081",
  PropertyAppraiserAndAssessor = "132020",
  PropertyRealEstateAndCommunityAssociationManager = "119141",
  PsychiatricTechnician = "292053",
  PublicRelationsAndFundraisingManager = "112030",
  PublicRelationsSpecialist = "273031",
  PublicSafetyTelecommunicator = "435031",
  PumpingStationOperator = "537070",
  PurchasingAgentExceptWholesaleRetailAndFarmProducts = "131023",
  PurchasingManager = "113061",
  RadiationTherapist = "291124",
  RadioAndTelecommunicationsEquipmentInstallerAndRepairer = "492020",
  RadiologicTechnologistAndTechnician = "292034",
  Radiologist = "291224",
  RailTrackLayingAndMaintenanceEquipmentOperator = "474061",
  RailroadConductorAndYardmaster = "534031",
  RealEstateBrokerAndSalesAgent = "419020",
  ReceptionistAndInformationClerk = "434171",
  RecreationWorker = "399032",
  RecreationalTherapist = "291125",
  RefuseAndRecyclableMaterialCollector = "537081",
  RegisteredNurse = "291141",
  RehabilitationCounselor = "211015",
  ReinforcingIronAndRebarWorker = "472171",
  ReligiousWorkerOther = "212099",
  ReservationAndTransportationTicketAgentAndTravelClerk = "434181",
  ResidentialAdvisor = "399041",
  RespiratoryTherapist = "291126",
  RetailSalesperson = "412031",
  Rigger = "499096",
  Roofer = "472181",
  RoustaboutOilAndGas = "475071",
  SailorAndMarineOiler = "535011",
  SalesAndRelatedWorkerOther = "419099",
  SalesEngineer = "419031",
  SalesManager = "112022",
  SalesRepresentativeOfServicesExceptAdvertisingInsuranceFinancialServicesAndTravel = "413091",
  SalesRepresentativesWholesaleAndManufacturing = "414010",
  SawingMachineSetterOperatorAndTenderWood = "517041",
  SchoolBusDriver = "533051",
  SchoolBusMonitor = "339094",
  SchoolPsychologist = "193034",
  SecondarySchoolTeacher = "252030",
  SecretaryAndAdministrativeAssistantExceptLegalMedicalAndExecutive = "436014",
  SecuritiesCommoditiesAndFinancialServicesSalesAgent = "413031",
  SecurityAndFireAlarmSystemsInstaller = "492098",
  SecurityGuardAndGamblingSurveillanceOfficer = "339030",
  SepticTankServicerAndSewerPipeCleaner = "474071",
  SewingMachineOperator = "516031",
  SheetMetalWorker = "472211",
  ShipAndBoatCaptainAndOperator = "535020",
  ShipEngineer = "535031",
  ShippingReceivingAndInventoryClerk = "435071",
  ShoeAndLeatherWorker = "516040",
  ShuttleDriverAndChauffeur = "533053",
  SkincareSpecialist = "395094",
  SmallEngineMechanic = "493050",
  SocialAndCommunityServiceManager = "119151",
  SocialAndHumanServiceAssistant = "211093",
  SocialScienceResearchAssistant = "194061",
  SocialWorkerOther = "211029",
  Sociologist = "193041",
  SoftwareDeveloper = "151252",
  SoftwareQualityAssuranceAnalystAndTester = "151253",
  SolarPhotovoltaicInstaller = "472231",
  SpecialEducationTeacher = "252050",
  SpeechLanguagePathologist = "291127",
  StationaryEngineerAndBoilerOperator = "518021",
  StatisticalAssistant = "439111",
  Statistician = "152041",
  StockerAndOrderFiller = "537065",
  StructuralIronAndSteelWorker = "472221",
  StructuralMetalFabricatorAndFitter = "512041",
  SubstanceAbuseAndBehavioralDisorderCounselor = "211011",
  SupervisorOfPersonalCareAndServiceWorker = "391000",
  SupervisorOfTransportationAndMaterialMovingWorker = "531000",
  Surgeon = "291240",
  SurgicalTechnologist = "292055",
  SurveyResearcher = "193022",
  SurveyingAndMappingTechnician = "173031",
  SurveyorCartographerAndPhotogrammetrist = "171020",
  SwitchboardOperatorIncludingAnsweringService = "432011",
  TailorDressmakerAndSewer = "516050",
  TaxExaminerAndCollectorAndRevenueAgent = "132081",
  TaxPreparer = "132082",
  TaxiDriver = "533054",
  TeachingAssistant = "259040",
  TechnicalWriter = "273042",
  TelecommunicationsLineInstallerAndRepairer = "499052",
  Telemarketer = "419041",
  TelephoneOperator = "432021",
  TelevisionVideoAndFilmCameraOperatorAndEditor = "274030",
  Teller = "433071",
  TextileMachineSetterOperatorAndTender = "516060",
  TherapistOther = "291129",
  TireBuilder = "519197",
  TitleExaminerAbstractorAndSearcher = "232093",
  ToolAndDieMaker = "514111",
  TourAndTravelGuide = "397010",
  TrainingAndDevelopmentManager = "113131",
  TrainingAndDevelopmentSpecialist = "131151",
  TransitAndIntercityBusDriver = "533052",
  TransportationInspector = "536051",
  TransportationSecurityScreener = "339093",
  TransportationServiceAttendant = "536030",
  TransportationStorageAndDistributionManager = "113071",
  TravelAgent = "413041",
  TreeTrimmerAndPruner = "373013",
  Tutor = "253041",
  UmpireRefereeAndOtherSportsOfficial = "272023",
  UndergroundMiningMachineOperator = "475040",
  UnemployedNoWorkExperience = "999999",
  Upholsterer = "516093",
  UrbanAndRegionalPlanner = "193051",
  UsherLobbyAttendantAndTicketTaker = "393031",
  Veterinarian = "291131",
  VeterinaryAssistantAndLaboratoryAnimalCaretaker = "319096",
  VeterinaryTechnologistAndTechnician = "292056",
  WaiterOrWaitress = "353031",
  WaterAndWastewaterTreatmentPlantAndSystemOperator = "518031",
  WebAndDigitalInterfaceDesigner = "151255",
  WebDeveloper = "151254",
  WeigherMeasurerCheckerAndSamplerRecordkeeping = "435111",
  WeldingSolderingAndBrazingWorker = "514120",
  WholesaleAndRetailBuyerExceptFarmProducts = "131022",
  WindTurbineServiceTechnician = "499081",
  WoodworkingMachineSetterOperatorAndTenderExceptSawing = "517042",
  WordProcessorAndTypist = "439022",
  WriterAndAuthor = "273043",
}

export enum SupportedRails {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
}

export enum PrimaryPurpose {
  BusinessTransactions = "business_transactions",
  CharitableDonations = "charitable_donations",
  InvestmentPurposes = "investment_purposes",
  Other = "other",
  PaymentsToFriendsOrFamilyAbroad = "payments_to_friends_or_family_abroad",
  PersonalOrLivingExpenses = "personal_or_living_expenses",
  ProtectWealth = "protect_wealth",
  PurchaseGoodsAndServices = "purchase_goods_and_services",
}

export enum CounterPartyProfileFIATUSLineOfBusiness {
  ArtsAndAntiques = "ARTS_AND_ANTIQUES",
  Agriculture = "AGRICULTURE",
  AuditVideo = "AUDIT_VIDEO",
  Automotive = "AUTOMOTIVE",
  BankCreditUnion = "BANK_CREDIT_UNION",
  BiotechPharmaceutical = "BIOTECH_PHARMACEUTICAL",
  Bookseller = "BOOKSELLER",
  Construction = "CONSTRUCTION",
  CasinosGambling = "CASINOS_GAMBLING",
  Clothing = "CLOTHING",
  ConsultingProfessionalServices = "CONSULTING_PROFESSIONAL_SERVICES",
  Cryptocurrency = "CRYPTOCURRENCY",
  EcigarettesTobacco = "ECIGARETTES_TOBACCO",
  EnergyChemicalFuel = "ENERGY_CHEMICAL_FUEL",
  Engineering = "ENGINEERING",
  AdultEntertainment = "ADULT_ENTERTAINMENT",
  FinancialAndCorporateServices = "FINANCIAL_AND_CORPORATE_SERVICES",
  FoodAndBeverage = "FOOD_AND_BEVERAGE",
  FreightMarineShippingServices = "FREIGHT_MARINE_SHIPPING_SERVICES",
  GiftwareSeasonal = "GIFTWARE_SEASONAL",
  GovernmentPublicServices = "GOVERNMENT_PUBLIC_SERVICES",
  HighTechSoftwareTelecoms = "HIGH_TECH_SOFTWARE_TELECOMS",
  Hospitality = "HOSPITALITY",
  HouseholdGoodFurniture = "HOUSEHOLD_GOOD_FURNITURE",
  HumanResourceServices = "HUMAN_RESOURCE_SERVICES",
  IndustrialEquipment = "INDUSTRIAL_EQUIPMENT",
  InformationTechnology = "INFORMATION_TECHNOLOGY",
  Insurance = "INSURANCE",
  JewelleryOptical = "JEWELLERY_OPTICAL",
  Law = "LAW",
  Manufacturing = "MANUFACTURING",
  Marketing = "MARKETING",
  MediaPublishing = "MEDIA_PUBLISHING",
  MedicalHealthcare = "MEDICAL_HEALTHCARE",
  MedicalTourism = "MEDICAL_TOURISM",
  Mining = "MINING",
  MoneyServiceBusiness = "MONEY_SERVICE_BUSINESS",
  NonProfitCharity = "NON_PROFIT_CHARITY",
  OnlineRetail = "ONLINE_RETAIL",
  Payroll = "PAYROLL",
  Pension = "PENSION",
  PersonalCareProducts = "PERSONAL_CARE_PRODUCTS",
  Photography = "PHOTOGRAPHY",
  RealEstate = "REAL_ESTATE",
  RecreationalActivities = "RECREATIONAL_ACTIVITIES",
  ReligiousOrganisation = "RELIGIOUS_ORGANISATION",
  Retail = "RETAIL",
  Security = "SECURITY",
  SportingRecreationalProducts = "SPORTING_RECREATIONAL_PRODUCTS",
  Transport = "TRANSPORT",
  UniversityEducation = "UNIVERSITY_EDUCATION",
  Utilities = "UTILITIES",
  WasteManagement = "WASTE_MANAGEMENT",
  WineLiquor = "WINE_LIQUOR",
  TechnicalSupport = "TECHNICAL_SUPPORT",
  Other = "OTHER",
}

export enum CounterPartyProfileFIATUSRelationshipToCustomer {
  Spouse = "SPOUSE",
  ExSpouse = "EX_SPOUSE",
  Children = "CHILDREN",
  Parent = "PARENT",
  Sibling = "SIBLING",
  Relative = "RELATIVE",
  Self = "SELF",
  Friend = "FRIEND",
  BusinessPartner = "BUSINESS_PARTNER",
  Customer = "CUSTOMER",
  Employee = "EMPLOYEE",
  BranchOffice = "BRANCH_OFFICE",
  SubsidiaryCompany = "SUBSIDIARY_COMPANY",
  HoldingCompany = "HOLDING_COMPANY",
  Supplier = "SUPPLIER",
  Creditor = "CREDITOR",
  Debtor = "DEBTOR",
  Franchisee = "FRANCHISEE",
  NotRelated = "NOT_RELATED",
}

export enum CounterPartyProfileLineOfBusiness {
  ArtsAndAntiques = "ARTS_AND_ANTIQUES",
  Agriculture = "AGRICULTURE",
  AuditVideo = "AUDIT_VIDEO",
  Automotive = "AUTOMOTIVE",
  BankCreditUnion = "BANK_CREDIT_UNION",
  BiotechPharmaceutical = "BIOTECH_PHARMACEUTICAL",
  Bookseller = "BOOKSELLER",
  Construction = "CONSTRUCTION",
  CasinosGambling = "CASINOS_GAMBLING",
  Clothing = "CLOTHING",
  ConsultingProfessionalServices = "CONSULTING_PROFESSIONAL_SERVICES",
  Cryptocurrency = "CRYPTOCURRENCY",
  EcigarettesTobacco = "ECIGARETTES_TOBACCO",
  EnergyChemicalFuel = "ENERGY_CHEMICAL_FUEL",
  Engineering = "ENGINEERING",
  AdultEntertainment = "ADULT_ENTERTAINMENT",
  FinancialAndCorporateServices = "FINANCIAL_AND_CORPORATE_SERVICES",
  FoodAndBeverage = "FOOD_AND_BEVERAGE",
  FreightMarineShippingServices = "FREIGHT_MARINE_SHIPPING_SERVICES",
  GiftwareSeasonal = "GIFTWARE_SEASONAL",
  GovernmentPublicServices = "GOVERNMENT_PUBLIC_SERVICES",
  HighTechSoftwareTelecoms = "HIGH_TECH_SOFTWARE_TELECOMS",
  Hospitality = "HOSPITALITY",
  HouseholdGoodFurniture = "HOUSEHOLD_GOOD_FURNITURE",
  HumanResourceServices = "HUMAN_RESOURCE_SERVICES",
  IndustrialEquipment = "INDUSTRIAL_EQUIPMENT",
  InformationTechnology = "INFORMATION_TECHNOLOGY",
  Insurance = "INSURANCE",
  JewelleryOptical = "JEWELLERY_OPTICAL",
  Law = "LAW",
  Manufacturing = "MANUFACTURING",
  Marketing = "MARKETING",
  MediaPublishing = "MEDIA_PUBLISHING",
  MedicalHealthcare = "MEDICAL_HEALTHCARE",
  MedicalTourism = "MEDICAL_TOURISM",
  Mining = "MINING",
  MoneyServiceBusiness = "MONEY_SERVICE_BUSINESS",
  NonProfitCharity = "NON_PROFIT_CHARITY",
  OnlineRetail = "ONLINE_RETAIL",
  Payroll = "PAYROLL",
  Pension = "PENSION",
  PersonalCareProducts = "PERSONAL_CARE_PRODUCTS",
  Photography = "PHOTOGRAPHY",
  RealEstate = "REAL_ESTATE",
  RecreationalActivities = "RECREATIONAL_ACTIVITIES",
  ReligiousOrganisation = "RELIGIOUS_ORGANISATION",
  Retail = "RETAIL",
  Security = "SECURITY",
  SportingRecreationalProducts = "SPORTING_RECREATIONAL_PRODUCTS",
  Transport = "TRANSPORT",
  UniversityEducation = "UNIVERSITY_EDUCATION",
  Utilities = "UTILITIES",
  WasteManagement = "WASTE_MANAGEMENT",
  WineLiquor = "WINE_LIQUOR",
  TechnicalSupport = "TECHNICAL_SUPPORT",
  Other = "OTHER",
}

export enum BridgeLiquidationAddressChain {
  "ARBITRUM" = "arbitrum",
  "AVALANCHE_C_CHAIN" = "avalanche_c_chain",
  "BASE" = "base",
  "ETHEREUM" = "ethereum",
  "OPTIMISM" = "optimism",
  "POLYGON" = "polygon",
  "SOLANA" = "solana",
  "STELLAR" = "stellar",
  "TRON" = "tron",
}

export enum BridgeVirtualAccountChain {
  "ARBITRUM" = "arbitrum",
  "AVALANCHE_C_CHAIN" = "avalanche_c_chain",
  "BASE" = "base",
  "ETHEREUM" = "ethereum",
  "OPTIMISM" = "optimism",
  "POLYGON" = "polygon",
  "SOLANA" = "solana",
  "STELLAR" = "stellar",
}

export enum BridgeVirtualAccountPaymentCurrency {
  "USDC" = "usdc",
  "USDT" = "usdt",
  "DAI" = "dai",
  "PYUSD" = "pyusd",
}

export enum CounterPartyLinkingDetailsMXLinkingProvider {
  Mx = "MX",
}

export enum IndividualCustomerUsResidencyStatus {
  UsCitizen = "US_CITIZEN",
  ResidentAlien = "RESIDENT_ALIEN",
  NonResidentAlien = "NON_RESIDENT_ALIEN",
}

export enum CorporationApplicationCorporateEntityType {
  CCorpPrivate = "C_CORP_PRIVATE",
  CCorpPublic = "C_CORP_PUBLIC",
  Hnwi = "HNWI",
  Llc = "LLC",
  Llp = "LLP",
  Lp = "LP",
  SCorp = "S_CORP",
  SoleProp = "SOLE_PROP",
  Trust = "TRUST",
  NonProfit = "NON_PROFIT",
  Other = "OTHER",
}

export enum InstructionCryptoInstructionType {
  Crypto = "CRYPTO",
  Ach = "ACH",
  Fedwire = "FEDWIRE",
}

export enum CounterPartyFIATCASupportedRails {
  Eft = "EFT",
  Swift = "SWIFT",
}

export enum TransactionOriginatorFIATOriginatorType {
  FiatUs = "FIAT_US",
  FiatUsLinked = "FIAT_US_LINKED",
  FiatCa = "FIAT_CA",
  FiatCaLinked = "FIAT_CA_LINKED",
  Crypto = "CRYPTO",
}

export enum TransactionOriginatorFIATUSRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
}

export enum WithdrawalType {
  FIAT = "FIAT",
  CRYPTO = "CRYPTO",
}

export enum CounterPartyAccountCRYPTOWalletType {
  Institution = "INSTITUTION",
  Other = "OTHER",
  Unknown = "UNKNOWN",
}

export enum CustomerCustomerType {
  Individual = "INDIVIDUAL",
  Corporation = "CORPORATION",
}

export enum CustomerStatus {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Frozen = "FROZEN",
  Pending = "PENDING",
  Edd = "EDD",
  Dormant = "DORMANT",
}

export enum CounterPartyFIATJPSupportedRails {
  Swift = "SWIFT",
}

export enum CounterPartyFIATCNSupportedRails {
  Swift = "SWIFT",
}

export enum DepositPullStatus {
  Requested = "REQUESTED",
  Executed = "EXECUTED",
  Failure = "FAILURE",
}

export enum DepositPullDepositType {
  Push = "PUSH",
  Pull = "PULL",
}

export enum ProfileCorporateKYCPrimaryBusiness {
  Software = "SOFTWARE",
  Atm = "ATM",
  Broker = "BROKER",
  Charity = "CHARITY",
  Commodities = "COMMODITIES",
  DefiExchange = "DEFI_EXCHANGE",
  GovernmentForeign = "GOVERNMENT_FOREIGN",
  GovernmentUs = "GOVERNMENT_US",
  Hnwi = "HNWI",
  Insurance = "INSURANCE",
  Advisor = "ADVISOR",
  Loan = "LOAN",
  Miner = "MINER",
  Nft = "NFT",
  NonBankCustodian = "NON_BANK_CUSTODIAN",
  Pension = "PENSION",
  Whv = "WHV",
  PooledInvestment = "POOLED_INVESTMENT",
  PropTrading = "PROP_TRADING",
  Public = "PUBLIC",
  Spv = "SPV",
  StateForeign = "STATE_FOREIGN",
  StateUs = "STATE_US",
  SupranationalBody = "SUPRANATIONAL_BODY",
  PaymentProcessor = "PAYMENT_PROCESSOR",
  TokenProject = "TOKEN_PROJECT",
  TrustPersonal = "TRUST_PERSONAL",
  TrustCorp = "TRUST_CORP",
  BankUs = "BANK_US",
  BankForeign = "BANK_FOREIGN",
  CryptoMsbUs = "CRYPTO_MSB_US",
  CryptoMsbForeign = "CRYPTO_MSB_FOREIGN",
  NonCryptoMsbUs = "NON_CRYPTO_MSB_US",
  NonCryptoMsbForeign = "NON_CRYPTO_MSB_FOREIGN",
  WholesalerDurable = "WHOLESALER_DURABLE",
  WholesalerNonDurable = "WHOLESALER_NON_DURABLE",
  RetailerDurable = "RETAILER_DURABLE",
  RetailerNonDurable = "RETAILER_NON_DURABLE",
  ConstructionsTrades = "CONSTRUCTION_TRADES",
  ProfessionalServices = "PROFESSIONAL_SERVICES",
  Other = "OTHER",
}

export enum ProfileCorporateKYCEngageInActivities {
  None = "NONE",
  AdultEntertainment = "ADULT_ENTERTAINMENT",
  Drugs = "DRUGS",
  Firearms = "FIREARMS",
  Gambling = "GAMBLING",
  Marijuana = "MARIJUANA",
  Tumbling = "TUMBLING",
}

export enum ProfileKYCVendorsAndCounterparties {
  Self = "SELF",
  MerchantsSuppliers = "MERCHANTS_SUPPLIERS",
  Customers = "CUSTOMERS",
  Employees = "EMPLOYEES",
  Contractors = "CONTRACTORS",
  Friends = "FRIENDS",
  Family = "FAMILY",
}

export enum ProfileCorporateKYCRegulatedStatus {
  Regulated = "REGULATED",
  Registered = "REGISTERED",
  Licensed = "LICENSED",
  None = "NONE",
  NotRequired = "NOT_REQUIRED",
}

export enum ProfileCorporateKYCControlExemptionReason {
  Regulated = "REGULATED",
  PubliclyTraded = "PUBLICLY_TRADED",
  PublicSubsidiary = "PUBLIC_SUBSIDIARY",
  PublicAccounting = "PUBLIC_ACCOUNTING",
  Insurance = "INSURANCE",
  GovernmentAgency = "GOVERNMENT_AGENCY",
  BankHolding = "BANK_HOLDING",
  SavingsLoan = "SAVINGS_LOAN",
  Fmu = "FMU",
  ForeignPrivateBank = "FOREIGN_PRIVATE_BANK",
  ForeignInstitution = "FOREIGN_INSTITUTION",
  Issuer = "ISSUER",
  Investment = "INVESTMENT",
  Commodities = "COMMODITIES",
  PooledInvestment = "POOLED_INVESTMENT",
  NonGovernmentSubdivision = "NON_GOVERNMENT_SUBDIVISION",
  NonEntity = "NON_ENTITY",
  None = "NONE",
}

export enum AccountAssetsFiatOptions {
  USD = "USD",
  EUR = "EUR",
}

export enum CounterPartyRailsType {
  ACH = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
}

export enum AccountAssetsCryptoOptions {
  BTC = "BTC",
  ETH = "ETH",
  USDC = "USDC",
  USDT = "USDT",
  DAI = "DAI",
  MATIC = "MATIC",
  SOL = "SOL",
  TRX = "TRX",
}

export enum BlockchainCryptoOptions {
  BITCOIN = "BITCOIN",
  ETHEREUM = "ETHEREUM",
  POLYGON = "POLYGON",
  SOLANA = "SOLANA",
  TRON = "TRON",
}

export enum AccountTypeOptions {
  FIAT = "FIAT",
  CRYPTO = "CRYPTO",
}

export enum FeesType {
  DOMESTIC = "domestic",
  DOMESTICIN = "domesticIn",
  SWIFT = "swift",
  SWIFTIN = "swiftIn",
  PROCESSING = "processingFee",
  CONVERSION = "conversionFee",
  ACH = "ach",
}

export enum CounterPartyProfileRelationshipToCustomer {
  Spouse = "SPOUSE",
  ExSpouse = "EX_SPOUSE",
  Children = "CHILDREN",
  Parent = "PARENT",
  Sibling = "SIBLING",
  Relative = "RELATIVE",
  Self = "SELF",
  Friend = "FRIEND",
  BusinessPartner = "BUSINESS_PARTNER",
  Customer = "CUSTOMER",
  Employee = "EMPLOYEE",
  BranchOffice = "BRANCH_OFFICE",
  SubsidiaryCompany = "SUBSIDIARY_COMPANY",
  HoldingCompany = "HOLDING_COMPANY",
  Supplier = "SUPPLIER",
  Creditor = "CREDITOR",
  Debtor = "DEBTOR",
  Franchisee = "FRANCHISEE",
  NotRelated = "NOT_RELATED",
}

export enum RequestExchangeAction {
  Destination = "FIX_DESTINATION",
  Source = "FIX_SOURCE",
}

export enum RequestIndividualIndividualType {
  Individual = "INDIVIDUAL",
  Officer = "OFFICER",
  BeneficialOwner = "BENEFICIAL_OWNER",
  ControlPerson = "CONTROL_PERSON",
  AuthorizedPerson = "AUTHORIZED_PERSON",
}

export enum WithdrawalCryptoWithdrawalRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
  Crypto = "CRYPTO",
  Eft = "EFT",
}

export enum IndividualIndividualType {
  BeneficialOwner = "BENEFICIAL_OWNER",
  ControlPerson = "CONTROL_PERSON",
}

export enum WithdrawalSwiftWithdrawalRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
  Crypto = "CRYPTO",
  Eft = "EFT",
}

export enum InstructionSwiftInstructionType {
  Crypto = "CRYPTO",
  Ach = "ACH",
  Fedwire = "FEDWIRE",
}

export enum IndividualFieldErrorFieldName {
  Id = "id",
  PersonRole = "person_role",
  PersonStatus = "person_status",
  FirstName = "first_name",
  MiddleName = "middle_name",
  LastName = "last_name",
  EmailAddress = "email_address",
  MailingAddressUnitNumber = "mailing_address.unit_number",
  MailingAddressAddressLine1 = "mailing_address.address_line1",
  MailingAddressAddressLine2 = "mailing_address.address_line2",
  MailingAddressAddressLine3 = "mailing_address.address_line3",
  MailingAddressCity = "mailing_address.city",
  MailingAddressState = "mailing_address.state",
  MailingAddressPostalCode = "mailing_address.postal_code",
  MailingAddressCountryCode = "mailing_address.country_code",
  TelephoneNumber = "telephone_number",
  TaxReferenceNumber = "tax_reference_number",
  PassportNumber = "passport_number",
  Nationality = "nationality",
  DateOfBirth = "date_of_birth",
  PercentageOwnership = "percentage_ownership",
  Title = "title",
  UsResidencyStatus = "us_residency_status",
}

export enum IndividualFieldErrorFieldStatus {
  Incomplete = "INCOMPLETE",
  ReadyForSubmission = "READY_FOR_SUBMISSION",
  ChangesRequested = "CHANGES_REQUESTED",
  Approved = "APPROVED",
}

export enum DocumentErrorStatus {
  Missing = "MISSING",
  Submitted = "SUBMITTED",
  ChangesRequested = "CHANGES_REQUESTED",
  Rejected = "REJECTED",
  Approved = "APPROVED",
}

export enum DocumentErrorDocument {
  DriversLicenceFront = "DRIVERS_LICENCE_FRONT",
  DriversLicenceBack = "DRIVERS_LICENCE_BACK",
  GovernmentIdFront = "GOVERNMENT_ID_FRONT",
  GovernmentIdBack = "GOVERNMENT_ID_BACK",
  Passport = "PASSPORT",
  UtilityBill = "UTILITY_BILL",
  FinancialStatement = "FINANCIAL_STATEMENT",
  LeaseAgreement = "LEASE_AGREEMENT",
  SocialSecurityCard = "SOCIAL_SECURITY_CARD",
  PowerOfAttorney = "POWER_OF_ATTORNEY",
  AnnualReport = "ANNUAL_REPORT",
  IncorporationDocuments = "INCORPORATION_DOCUMENTS",
  PartnershipAgreement = "PARTNERSHIP_AGREEMENT",
  LlcAgreement = "LLC_AGREEMENT",
  Layer2AccountAgreement = "LAYER2_ACCOUNT_AGREEMENT",
  AccountAgreement = "ACCOUNT_AGREEMENT",
}

export enum CounterPartyFIATUSSupportedRails {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
}

export enum CounterPartyFIATBSSupportedRails {
  Ach = "ACH",
  Swift = "SWIFT",
}

export enum ApplicationCorporationApplicationType {
  Individual = "INDIVIDUAL",
  Corporation = "CORPORATION",
}

export enum TransactionDetailsTransactionStatus {
  Authorized = "AUTHORIZED",
  Pending = "PENDING",
  Posted = "POSTED",
  Cancelled = "CANCELLED",
}

export enum TransactionDetailsTransactionType {
  TransferIn = "TRANSFER_IN",
  TransferOut = "TRANSFER_OUT",
  Fee = "FEE",
  DebitCorrection = "DEBIT_CORRECTION",
  CreditCorrection = "CREDIT_CORRECTION",
  Trade = "TRADE",
  InternalTransfer = "INTERNAL_TRANSFER",
}

export enum TransactionDetailsCategoryType {
  Adjustment = "ADJUSTMENT",
  Deposit = "DEPOSIT",
  Exchange = "EXCHANGE",
  Transfer = "TRANSFER",
  Withdrawal = "WITHDRAWAL",
}

export enum InstructionAchInstructionType {
  Crypto = "CRYPTO",
  Ach = "ACH",
  Fedwire = "FEDWIRE",
}

export enum TransferStatus {
  Requested = "REQUESTED",
  Accepted = "ACCEPTED",
  Expired = "EXPIRED",
  Cancelled = "CANCELLED",
  Executed = "EXECUTED",
  Rejected = "REJECTED",
}

export enum CounterPartyLinkingConnectLinkingProvider {
  Mx = "MX",
}

export enum TransactionOriginatorFIATCARail {
  Eft = "EFT",
  Swift = "SWIFT",
}

export enum AdjustmentDebitAdjustmentType {
  Credit = "CREDIT",
  Debit = "DEBIT",
}

export enum DepositBaseStatus {
  Requested = "REQUESTED",
  Executed = "EXECUTED",
  Failure = "FAILURE",
}

export enum InstructionFedwireInstructionType {
  Crypto = "CRYPTO",
  Ach = "ACH",
  Fedwire = "FEDWIRE",
}

export enum CounterPartyFIATEUSupportedRails {
  SepaCt = "SEPA_CT",
  Swift = "SWIFT",
}

export enum ApplicationStateStatus {
  Incomplete = "INCOMPLETE",
  ReadyForSubmission = "READY_FOR_SUBMISSION",
  Submitted = "SUBMITTED",
  Processing = "PROCESSING",
  ChangesRequested = "CHANGES_REQUESTED",
  Rejected = "REJECTED",
  Approved = "APPROVED",
}

export enum ApplicationStateApplicationType {
  Individual = "INDIVIDUAL",
  Corporation = "CORPORATION",
}

export enum ApplicationStateApplicationErrors {
  BeneficialOwner = "MISSING_BENEFICIAL_OWNER",
  Officer = "MISSING_OFFICER",
  Person = "MISSING_PERSON",
}

export enum CounterPartyLinkingAccountsMXLinkingProvider {
  Mx = "MX",
}

export enum DepositPushStatus {
  Requested = "REQUESTED",
  Executed = "EXECUTED",
  Failure = "FAILURE",
}

export enum DepositPushDepositType {
  Push = "PUSH",
  Pull = "PULL",
}

export enum TransactionOriginatorAccountCRYPTOWalletType {
  Institution = "INSTITUTION",
  Other = "OTHER",
  Unknown = "UNKNOWN",
}

export enum CounterPartyLinkingConnectMXLinkingProvider {
  Mx = "MX",
}

export enum CounterPartyFIATINSupportedRails {
  Imps = "IMPS",
  Nft = "NFT",
  Up = "UP",
  Swift = "SWIFT",
}

export enum ExchangeStatus {
  Requested = "REQUESTED",
  Accepted = "ACCEPTED",
  Expired = "EXPIRED",
  Cancelled = "CANCELLED",
  Executed = "EXECUTED",
  Rejected = "REJECTED",
}

export enum ExchangeExchangeType {
  Quote = "QUOTE",
  Market = "MARKET",
}

export enum ExchangeAction {
  Destination = "FIX_DESTINATION",
  Source = "FIX_SOURCE",
}

export enum CounterPartyAccountFIATUSType {
  Checking = "CHECKING",
  Saving = "SAVING",
}

export enum CounterPartyAccountFIATBSType {
  Checking = "CHECKING",
  Saving = "SAVING",
}

export enum SettlementSettlementStatus {
  Initialized = "INITIALIZED",
  Delivering = "DELIVERING",
  Converting = "CONVERTING",
  Settled = "SETTLED",
}

export enum SettlementSettlementAssetType {
  Fiat = "FIAT",
  Bitcoin = "BITCOIN",
  Ethereum = "ETHEREUM",
  Polygon = "POLYGON",
}

export enum TransactionOriginatorCRYPTOOriginatorType {
  FiatUs = "FIAT_US",
  FiatUsLinked = "FIAT_US_LINKED",
  FiatCa = "FIAT_CA",
  FiatCaLinked = "FIAT_CA_LINKED",
  Crypto = "CRYPTO",
}

export enum TransactionOriginatorCRYPTORail {
  Crypto = "CRYPTO",
}

export enum SettlementDetailsSourceAssetType {
  Fiat = "FIAT",
  Bitcoin = "BITCOIN",
  Ethereum = "ETHEREUM",
  Polygon = "POLYGON",
}

export enum SettlementDetailsDestinationAssetType {
  Fiat = "FIAT",
  Bitcoin = "BITCOIN",
  Ethereum = "ETHEREUM",
  Polygon = "POLYGON",
}

export enum TransactionTransactionStatus {
  Authorized = "AUTHORIZED",
  Pending = "PENDING",
  Posted = "POSTED",
  Cancelled = "CANCELLED",
}

export enum TransactionTransactionType {
  TransferIn = "TRANSFER_IN",
  TransferOut = "TRANSFER_OUT",
  Fee = "FEE",
  DebitCorrection = "DEBIT_CORRECTION",
  CreditCorrection = "CREDIT_CORRECTION",
  Trade = "TRADE",
  InternalTransfer = "INTERNAL_TRANSFER",
}

export enum TransactionCategoryType {
  Adjustment = "ADJUSTMENT",
  Deposit = "DEPOSIT",
  Exchange = "EXCHANGE",
  Transfer = "TRANSFER",
  Withdrawal = "WITHDRAWAL",
}

export enum CounterPartyFIATHKSupportedRails {
  Swift = "SWIFT",
}

export enum AdjustmentStatus {
  Requested = "REQUESTED",
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Executed = "EXECUTED",
  Rejected = "REJECTED",
}

export enum AdjustmentCreditAdjustmentType {
  Credit = "CREDIT",
  Debit = "DEBIT",
}

export enum CounterPartyFIATUSLINKEDSupportedRails {
  Ach = "ACH",
}

export enum CounterPartyCounterpartyType {
  FiatUs = "FIAT_US",
  FiatUsLinked = "FIAT_US_LINKED",
  FiatCa = "FIAT_CA",
  FiatCaLinked = "FIAT_CA_LINKED",
  Crypto = "CRYPTO",
}

export enum CounterPartyFIATSGSupportedRails {
  Swift = "SWIFT",
}

export enum SubscriptionEventType {
  ApplicationReadyForSubmission = "APPLICATION_READY_FOR_SUBMISSION",
  ApplicationSubmitted = "APPLICATION_SUBMITTED",
  ApplicationProcessing = "APPLICATION_PROCESSING",
  ApplicationChangeRequested = "APPLICATION_CHANGE_REQUESTED",
  ApplicationRejected = "APPLICATION_REJECTED",
  ApplicationApproved = "APPLICATION_APPROVED",
  CustomerActive = "CUSTOMER_ACTIVE",
  CustomerClosed = "CUSTOMER_CLOSED",
  CustomerPending = "CUSTOMER_PENDING",
  CustomerEDD = "CUSTOMER_EDD",
  CustomerFrozen = "CUSTOMER_FROZEN",
  AccountOpen = "ACCOUNT_OPEN",
  AccountClosed = "ACCOUNT_CLOSED",
  AccountFrozen = "ACCOUNT_FROZEN",
  AccountPending = "ACCOUNT_PENDING",
  AccountEDD = "ACCOUNT_EDD",
  AccountDormant = "ACCOUNT_DORMANT",
  TransactionAuthorized = "TRANSACTION_AUTHORIZED",
  TransactionPending = "TRANSACTION_PENDING",
  TransactionPosted = "TRANSACTION_POSTED",
  TransactionCancelled = "TRANSACTION_CANCELLED",
}

export enum DepositStatus {
  Requested = "REQUESTED",
  Executed = "EXECUTED",
  Failure = "FAILURE",
}

export enum DepositDepositType {
  Push = "PUSH",
  Pull = "PULL",
}

export enum CounterPartyFIATMYSupportedRails {
  Swift = "SWIFT",
}

export enum CounterPartyIntermediaryIntermediaryType {
  Us = "FIAT_US",
  Ca = "FIAT_CA",
  Pa = "FIAT_PA",
  My = "FIAT_MY",
  Jp = "FIAT_JP",
  Sg = "FIAT_SG",
  Hk = "FIAT_HK",
  Cn = "FIAT_CN",
  Bs = "FIAT_BS",
  Gb = "FIAT_GB",
  In = "FIAT_IN",
  Eu = "FIAT_EU",
}

export enum CounterPartyLinkingDetailsLinkingProvider {
  Mx = "MX",
}

export enum ApplicationIndividualApplicationType {
  Individual = "INDIVIDUAL",
  Corporation = "CORPORATION",
}

export enum WithdrawalStatus {
  Requested = "REQUESTED",
  Rejected = "REJECTED",
  Expired = "EXPIRED",
  Accepted = "ACCEPTED",
  Executed = "EXECUTED",
  Cancelled = "CANCELLED",
}

export enum WithdrawalWithdrawalRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
  Crypto = "CRYPTO",
  Eft = "EFT",
}

export enum WithdrawalPurpose {
  PersonalAccount = "PERSONAL_ACCOUNT",
  Family = "FAMILY",
  Insurance = "INSURANCE",
  Investment = "INVESTMENT",
  RealEstate = "REAL_ESTATE",
  Tuition = "TUITION",
  Medical = "MEDICAL",
  Travel = "TRAVEL",
  TradeTransactions = "TRADE_TRANSACTIONS",
  Utility = "UTILITY",
  Tax = "TAX",
  Loan = "LOAN",
  Bills = "BILLS",
  Payroll = "PAYROLL",
  Telecom = "TELECOM",
  IntellectualProperty = "INTELLECTUAL_PROPERTY",
  OtherBusinessServices = "OTHER_BUSINESS_SERVICES",
  CharitableDonations = "CHARITABLE_DONATIONS",
  Mortgage = "MORTGAGE",
  ExpensesReimbursement = "EXPENSES_REIMBURSEMENT",
  ProfessionalServices = "PROFESSIONAL_SERVICES",
  Marketing = "MARKETING",
  RentalProperty = "RENTAL_PROPERTY",
  Other = "OTHER",
}

export enum TransactionOriginatorOriginatorType {
  FiatUs = "FIAT_US",
  FiatUsLinked = "FIAT_US_LINKED",
  FiatCa = "FIAT_CA",
  FiatCaLinked = "FIAT_CA_LINKED",
  Crypto = "CRYPTO",
}

export enum CounterPartyFIATGBSupportedRails {
  Fps = "FPS",
  Swift = "SWIFT",
}

export enum RequestCustomerCustomerType {
  Individual = "INDIVIDUAL",
  Corporation = "CORPORATION",
}

export enum RequestCustomerStatus {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Frozen = "FROZEN",
  Pending = "PENDING",
  Edd = "EDD",
  Dormant = "DORMANT",
}

export enum CounterPartyCRYPTOSupportedRails {
  Crypto = "CRYPTO",
}

export enum CounterPartyLinkingAccountsLinkingProvider {
  Mx = "MX",
}

export enum TransferBaseStatus {
  Requested = "REQUESTED",
  Accepted = "ACCEPTED",
  Expired = "EXPIRED",
  Cancelled = "CANCELLED",
  Executed = "EXECUTED",
  Rejected = "REJECTED",
}

export enum WithdrawalACHWithdrawalRail {
  Ach = "ACH",
  Fedwire = "FEDWIRE",
  Swift = "SWIFT",
  Crypto = "CRYPTO",
  Eft = "EFT",
}
